'use client'

import { ToastContainer } from 'react-toastify'

export default function ToastContainerClient() {
  // Black text (not the default white) — the colored/shiny toast backgrounds
  // made white text hard to read. Inline toastStyle overrides the theme color.
  return <ToastContainer position='top-center' autoClose={3500} newestOnTop pauseOnHover theme='colored' toastStyle={{ color: '#111111' }} />
}
